module.exports = __webpack_public_path__ + "img/juan_gonzalez.e58f3f5f.png";